let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("4yAaN")).then(() => parcelRequire('4vwHe'));